module.exports = __webpack_public_path__ + "static/img/arrow-down.d8ea3d3f.svg";